import React from "react";
import { Link } from "react-router-dom";
import { brainScreenStyle } from "../brainBackground";

export default function LegalPageLayout({ title, children }) {
  return (
    <div
      style={{
        ...brainScreenStyle(),
        minHeight: "100vh",
        padding: "24px 20px 48px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          maxWidth: 640,
          margin: "0 auto",
          background: "rgba(28,34,58,0.82)",
          borderRadius: 16,
          padding: "28px 24px 32px",
          color: "#f0f4ff",
          lineHeight: 1.55,
          fontFamily: "'Montserrat', 'Open Sans', Arial, sans-serif",
          boxShadow: "0 8px 32px rgba(0,0,0,0.35)",
        }}
      >
        <h1
          style={{
            margin: "0 0 20px",
            fontSize: "1.65rem",
            fontWeight: 900,
            color: "#ffe066",
          }}
        >
          {title}
        </h1>
        {children}
        <p style={{ marginTop: 28, fontSize: "0.9rem" }}>
          <Link to="/play/" style={{ color: "#99ffc9" }}>
            ← Back to join
          </Link>
        </p>
      </div>
    </div>
  );
}
